export default __webpack_public_path__ + "static/hidroelectrico-porce-1e7e8bf2ff95d85826b20ed82c9627e4.jpg";